<template>
  <div :class="{ 'drop-hover': collect.isOver && collect.canDrop }" ref="dropEl">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useDrop } from 'vue3-dnd'
import { ref, onMounted } from 'vue'

const props = defineProps<{
  targetId: string
}>()

const emit = defineEmits<{
  (e: 'move-row', sourceId: string, targetId: string, row: any): void
}>()

const dropEl = ref<HTMLElement | null>(null)

// useDrop возвращает [collectRef, drop]
const [collect, drop] = useDrop(() => ({
  accept: 'ROW',
  drop: (item: any) => {
    emit('move-row', item.sourceId, props.targetId, item.row)
  },
  collect: (monitor) => ({
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  })
}))

onMounted(() => {
  if (dropEl.value) drop(dropEl.value)
})
</script>
